import React from 'react'

const SeparadorO = () => {
    return (
        <>
            <div className="my-2 flex justify-center items-center">
                <div className="self-center flex h-1 w-full border-b border-gray-200"></div>
                <span className="text-gray-700 mx-2">o</span>
                <div className="self-center flex h-1 w-full border-b border-gray-200"></div>
            </div>
        </>
    )
}

export default SeparadorO
